import { useTranslation } from 'react-i18next'

import {
  performMockViewingsBook,
  performMockViewingsCreate,
} from '../../../RentalPortalViewing.mocks'
import { VIEWING_FORM_FIELD_NAME } from '../../RentalPortalViewingFormModal.constants'
import { getIsViewingFormBookMode } from '../../RentalPortalViewingFormModal.utils'
import { getViewingFormSubmitErrors } from '../../RentalPortalViewingFormModal.utils.validation'

export function useViewingFormSubmit({
  slotsReloadRef,
  onBooked,
  onClose,
  onCreated,
}) {
  const { t } = useTranslation()

  async function handleBookSubmit({
    setErrors,
    setFieldValue,
    setSubmitting,
    value,
  }) {
    return performMockViewingsBook(value)
      .then(() => {
        onBooked()
        onClose()
      })
      .catch(error => {
        setSubmitting(false)

        if (error?.isSlotTaken) {
          setFieldValue(VIEWING_FORM_FIELD_NAME.slot, null)

          slotsReloadRef.current?.()
        }

        setErrors(getViewingFormSubmitErrors({ error, t }))
      })
  }

  async function handleSlotsSubmit({ setErrors, setSubmitting, value }) {
    return performMockViewingsCreate(value)
      .then(({ data }) => {
        onCreated(data.created_count)
        onClose()
      })
      .catch(error => {
        setSubmitting(false)

        setErrors(getViewingFormSubmitErrors({ error, t }))
      })
  }

  async function handleSubmit(formikHelpers) {
    return getIsViewingFormBookMode(formikHelpers.values)
      ? handleBookSubmit(formikHelpers)
      : handleSlotsSubmit(formikHelpers)
  }

  return { handleSubmit }
}
